import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { SegnalibroConProva, SegnalibroService } from '../../services/segnalibro.service';

@Component({
  selector: 'segnalibri',
  templateUrl: './segnalibri.component.html',
  styleUrls: ['./segnalibri.component.scss']
})
export class SegnalibriComponent implements OnInit {

  constructor(
    private segnalibroService: SegnalibroService,
    private fb: FormBuilder,
  ) { }

  segnalibri$: Observable<SegnalibroConProva[]>;

  form: FormGroup;

  ngOnInit(): void {

    this.form = this.fb.group({
      incarico: [],
    });

    this.form.valueChanges
      .pipe(
        startWith(
          {
            incarico: {
              id: 1
            }
          }
        )
      ).subscribe(v => this.segnalibri$ = this.segnalibroService.provaSegnalibriSu(v?.incarico?.id));
  }

}
